/** FAQ entries (max 20). Keys are used with `useKivunovaTranslation` fallbacks. */
import type { FaqItem } from "../types";

export const FAQ_ITEMS: FaqItem[] = [
  {
    id: "what-is-fms",
    questionKey: "faq-what-is-fms-q",
    questionFallback: "What is Kivunova FMS?",
    answerKey: "faq-what-is-fms-a",
    answerFallback:
      "Kivunova FMS helps you manage products, stock, orders, stores, and money in one place, built for growing businesses in Rwanda and beyond."
  },
  {
    id: "who-is-it-for",
    questionKey: "faq-who-is-it-for-q",
    questionFallback: "Who is Kivunova FMS for?",
    answerKey: "faq-who-is-it-for-a",
    answerFallback:
      "Retailers, wholesalers, and multi-store operators who need one place to manage products, stock, sales, and company settings with role-based access for staff."
  },
  {
    id: "languages",
    questionKey: "faq-languages-q",
    questionFallback: "Which languages are supported?",
    answerKey: "faq-languages-a",
    answerFallback:
      "The app supports English, French, Kinyarwanda, and Swahili. You can switch language from the selector in the top bar."
  },
  {
    id: "multi-store",
    questionKey: "faq-multi-store-q",
    questionFallback: "Can I manage multiple stores?",
    answerKey: "faq-multi-store-a",
    answerFallback:
      "Yes. Company administrators can create and manage multiple stores, assign store admins, and view activity per location."
  },
  {
    id: "inventory",
    questionKey: "faq-inventory-q",
    questionFallback: "How does inventory tracking work?",
    answerKey: "faq-inventory-a",
    answerFallback:
      "Your product list shows what you sell. Stock is tracked for each item in each store. Levels update when you record sales, purchases, and stock changes."
  },
  {
    id: "orders",
    questionKey: "faq-orders-q",
    questionFallback: "What order types are supported?",
    answerKey: "faq-orders-a",
    answerFallback:
      "You can record sales and purchases, with invoices and receipts depending on your plan."
  },
  {
    id: "roles",
    questionKey: "faq-roles-q",
    questionFallback: "What user roles exist?",
    answerKey: "faq-roles-a",
    answerFallback:
      "Kivunova FMS uses company-level and store-level roles. See the roles and access page for a full list and who can invite employees."
  },
  {
    id: "signup",
    questionKey: "faq-signup-q",
    questionFallback: "How do I create an account?",
    answerKey: "faq-signup-a",
    answerFallback:
      "From the welcome screen, choose Get started or Register, complete company and user details, and verify your email when prompted."
  },
  {
    id: "login-issues",
    questionKey: "faq-login-issues-q",
    questionFallback: "I cannot log in. What should I do?",
    answerKey: "faq-login-issues-a",
    answerFallback:
      "Use Forgot password to reset your password. Make sure your account is active and you are using the correct company email. Contact us if the problem continues."
  },
  {
    id: "desktop-mobile",
    questionKey: "faq-desktop-mobile-q",
    questionFallback: "Is there a desktop or mobile app?",
    answerKey: "faq-desktop-mobile-a",
    answerFallback:
      "Yes. Visit Download apps for computer apps (Windows and Mac) and phone apps when available. The website version uses the same account."
  },
  {
    id: "data-security",
    questionKey: "faq-data-security-q",
    questionFallback: "How is my data protected?",
    answerKey: "faq-data-security-a",
    answerFallback:
      "Access is authenticated and encrypted in transit. Role-based permissions limit who can view or change company and store data."
  },
  {
    id: "billing",
    questionKey: "faq-billing-q",
    questionFallback: "How does billing work?",
    answerKey: "faq-billing-a",
    answerFallback:
      "Plans and subscriptions are available in the Membership area after you sign in. Each plan includes different features and limits for your business."
  },
  {
    id: "reports",
    questionKey: "faq-reports-q",
    questionFallback: "Can I see sales and inventory reports?",
    answerKey: "faq-reports-a",
    answerFallback:
      "Your home screen shows sales, stock movement, and top products. More reports may be available depending on your plan."
  },
  {
    id: "currency",
    questionKey: "faq-currency-q",
    questionFallback: "Which currency is used?",
    answerKey: "faq-currency-a",
    answerFallback:
      "You choose your currency when you set up your company (for example RWF). Amounts across the app use that currency."
  },
  {
    id: "offline",
    questionKey: "faq-offline-q",
    questionFallback: "Does Kivunova FMS work offline?",
    answerKey: "faq-offline-a",
    answerFallback:
      "You need an internet connection to use Kivunova FMS in your browser. The installed computer app may show some screens offline, but your latest data updates when you are back online."
  },
  {
    id: "support",
    questionKey: "faq-support-q",
    questionFallback: "How do I contact support?",
    answerKey: "faq-support-a",
    answerFallback:
      "Use the floating Contact us button, or email support. We aim to respond within one business day."
  },
  {
    id: "training",
    questionKey: "faq-training-q",
    questionFallback: "Is training available?",
    answerKey: "faq-training-a",
    answerFallback:
      "Start with the User guide and Run books for everyday tasks. Larger businesses can request dedicated training."
  },
  {
    id: "integrations",
    questionKey: "faq-integrations-q",
    questionFallback: "Are integrations available?",
    answerKey: "faq-integrations-a",
    answerFallback:
      "Connecting to other systems depends on your plan. Contact us to talk about tills, accounting software, or other tools."
  },
  {
    id: "cancel",
    questionKey: "faq-cancel-q",
    questionFallback: "How do I cancel or close my account?",
    answerKey: "faq-cancel-a",
    answerFallback:
      "Contact us to change your plan or close your account. We will help you save your data where possible."
  },
  {
    id: "product-vs-product-items",
    questionKey: "faq-product-vs-product-items-q",
    questionFallback:
      "What is the difference between a product and a product item?",
    answerKey: "faq-product-vs-product-items-a",
    answerFallback:
      "A product is your catalog listing; product items hold stock in each store. See the products vs. product items page for a full explanation."
  }
];
